import { IFrameStore } from '@rift/service/validation/database/syncrecording/IFrameStore';
import { IObjectStore } from '@shared/service/Indexeddb/IObjectStore';

export interface IDatabaseVideoSettingFramesStore extends IFrameStore {
}

export class DatabaseVideoSettingFramesStore implements IObjectStore {
    public static readonly keyPath: string = 'id';
    public static readonly recordingIdBlockIndex: string = 'RecordingIdBlockIndex';
    public static readonly recordingIdFrameNumberIndex: string = 'RecordingIdFrameNumberIndex';
    public static readonly recordingIdIndex: string = 'RecordingIdIndex';
    public static readonly recordingIdTimestamp: string = 'RecordingIdTimestamp';
    public static readonly storeDisplayName: string = 'Settings';
    public static readonly storeName: string = 'videosetting';

    public get storeName(): string {
        return DatabaseVideoSettingFramesStore.storeName
    };

    public static toInterface(): IDatabaseVideoSettingFramesStore {
        return {
            storeName: this.storeName,
            keyPath: this.keyPath,
            recordingIdFrameNumberIndex: this.recordingIdFrameNumberIndex,
            recordingIdIndex: this.recordingIdIndex,
            recordingIdBlockIndex: this.recordingIdBlockIndex,
        } as IDatabaseVideoSettingFramesStore;
    }

    public createStores(db: IDBDatabase): void {
        const store: IDBObjectStore = db.createObjectStore(DatabaseVideoSettingFramesStore.storeName, { keyPath: DatabaseVideoSettingFramesStore.keyPath, autoIncrement: true });
        store.createIndex(DatabaseVideoSettingFramesStore.recordingIdFrameNumberIndex, ['recordingId', 'frameNumber'], { unique: true });
        store.createIndex(DatabaseVideoSettingFramesStore.recordingIdBlockIndex, ['recordingId', 'block']);
        store.createIndex(DatabaseVideoSettingFramesStore.recordingIdIndex, 'recordingId');
    }
}
